import Keycloak from 'keycloak-js'

// Single shared instance — never re-create this across re-renders.
const keycloak = new Keycloak({
  url:      import.meta.env.VITE_KEYCLOCK_URL ?? 'https://auth.multiaccess.in/',
  realm:    'multiaccess',
  clientId: 'multiaccessclient',
})

export default keycloak
